module.exports = __webpack_public_path__ + "fe25c60ca99d3bb1bb33454bc927173b.svg";